import {BaseStore} from '../base';
import {action, observable, toJS} from 'mobx';
import {callSmsGetAll} from '../../helpers/api/sms';

export class SmsListStore extends BaseStore {
  @observable page = 1;
  @observable pageSize = 50;
  @observable filters = {
    phone: null,
    date: null
  };

  @observable isLoading = false;
  @observable items = null;
  @observable total = 0;

  @action async changePageAndLoad(page, pageSize) {
    this.page = page;
    this.pageSize = pageSize;
    await this.load();
  }

  @action async applyFiltersAndLoad() {
    await this.load();
  }

  @action async load() {
    this.isLoading = true;

    const data = await callSmsGetAll({
      limit: this.pageSize,
      offset: (this.pageSize * this.page) - this.pageSize,
      ...toJS(this.filters)
    });
    
    this.items = data.items;
    this.total = data.total;

    this.isLoading = false;
  }

  @action patchFilters(partialFilters) {
    this.filters = { ...toJS(this.filters), ...partialFilters };
  }

  @action resetFilters() {
    this.filters = {};
  }
}



// WEBPACK FOOTER //
// ./src/stores/sms/sms-list-store.js